import React from 'react';
const useTime = (initialSeconds, step = 1000, intervalDuration = 1000) => {
    const [isActive, setIsActive] = React.useState(false);
    const [miliseconds, setMiliseconds] = React.useState(initialSeconds * 1000);
    const start = React.useCallback(() => {
        setMiliseconds(initialSeconds * 1000);
        setIsActive(true);
    }, [initialSeconds]);
    const stop = React.useCallback(() => {
        setMiliseconds(0);
        setIsActive(false);
    }, []);
    React.useEffect(() => {
        let interval = undefined;
        if (isActive && miliseconds !== 0) {
            interval = setInterval(() => {
                setMiliseconds(miliseconds => miliseconds - step);
            }, intervalDuration);
        }
        else if (!isActive) {
            clearInterval(interval);
        }
        else {
            stop();
        }
        return () => clearInterval(interval);
    }, [isActive, miliseconds, step, intervalDuration, stop]);
    return [start, stop, miliseconds, isActive];
};
export default useTime;
